module.exports = __webpack_public_path__ + "static/media/about-bg-tablet.3693b42c.jpg";